import React from 'react';

import { Switch, Route } from 'react-router-dom';

import TicketTable from './table.js'

export default (props) => {
    return(
        <Switch>
            <Route exact path='/insidencias' component={TicketTable} />
           
        </Switch>
    )
}





// WEBPACK FOOTER //
// ./src/views/insidencias/index.js